<template>
  <div class="wrapper">
    <v-overlay v-if="loading">
      <v-progress-circular indeterminate size="124"></v-progress-circular>
    </v-overlay>
    <v-container v-if="loading === false">
      <v-row>
        <v-col style="padding: 0px">
          <IconBox
            iconBGColor1="#34495e"
            iconBGColor2="#2c3e50"
            footer="Overview of consultant levels"
          >
            <div slot="icon">
              <v-icon color="white">mdi-align-vertical-bottom</v-icon>
            </div>
            <template slot="content">
              <IconBoxContent title="" value="Consultant Levels" />
            </template>
          </IconBox>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="padding: 0px">
          <v-card>
            <v-toolbar flat dense elevation="0" dark color="color">
              <v-spacer />
              <v-text-field
                v-model="filter"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer />
            </v-toolbar>
          </v-card>
          <v-card>
            <v-card-subtitle
              >Amount of consultants:
              {{ filteredEmployees.length }}</v-card-subtitle
            >
            <v-container>
              <v-row>
                <v-col
                  v-for="(key, attributeName) in employeesGroupedByLevel"
                  :key="attributeName"
                >
                  <v-card-title>{{ attributeName }}</v-card-title>
                  <v-card-text>
                    <div v-for="employee in key" :key="employee.id">
                      {{ employee.firstName }} {{ employee.lastName }}
                    </div>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import IconBox from "@/components/IconBox.vue";
import IconBoxContent from "@/components/IconBoxContent.vue";
import moment from "moment";
import * as R from "ramda";
import levelOrders from "@/utility/levelOrders.js";

export default {
  name: "ConsultantLevels",
  data() {
    return {
      loading: true,
      employees: [],
      filter: "",
    };
  },
  mounted() {
    this.getAllEmployees();
  },
  methods: {
    async getAllEmployees() {
      try {
        console.log('getting all employees');
        this.loading = true;
        const employees = (await this.$store.dispatch("adminGetAllEmployees"))
          .data;

        this.$data.employees = employees.filter(
          (emp) =>
            moment(new Date()).isBefore(moment(emp.endOfEmployment)) ||
            emp.endOfEmployment === null
        );
      } catch (err) {
        window.errorHandler.logError(
          err,
          "components/EmployeesEditor.vue - loadEmployees"
        );
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    employeeLevels() {
      return [...new Set(this.employees.map((emp) => emp.benefitName))];
    },
    filteredEmployees() {
      return this.employees
        .filter((emp) => {
          if (emp.benefitName === "Office Manager") {
            return false;
          }
          if (emp.benefitName === "Team Manager") {
            return false;
          }
          if (emp.benefitName === "Technical Director") {
            return false;
          }
          if (emp.benefitName === "COO") {
            return false;
          }
          if (emp.benefitName === "CEO") {
            return false;
          }
          if (emp.benefitName && emp.benefitName.includes("Level")) {
            return false;
          }
          return true;
        })
        .filter((emp) => {
          if (!this.filter) {
            return true;
          }
          const fullName = `${emp.firstName} ${emp.lastName}`;
          const regex = new RegExp(this.filter, "i");
          return fullName.match(regex);
        })
        .sort((a, b) => {
          const fullNameA = `${a.firstName} ${a.lastName}`;
          const fullNameB = `${b.firstName} ${b.lastName}`;
          return (
            levelOrders[a.benefitName] - levelOrders[b.benefitName] ||
            fullNameA.localeCompare(fullNameB)
          );
        });
    },
    employeesGroupedByLevel() {
      const byBenefit = R.groupBy((emp) => emp.benefitName);
      const emps = byBenefit(this.filteredEmployees);
      return emps;
    },
  },
  components: { IconBox, IconBoxContent },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding-top: 25px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px;
  width: 80%;

  @media screen and (max-width: 480px) {
    width: 90%;
    padding-top: 0px;
  }
}
</style>